/**
 * The colour a pool is drawn in, wherever it appears.
 *
 * The comparison-series scale, so a pool keeps one colour from its strategy
 * card to the chart line that compares it. The three strategy pools are named;
 * any other pool (the physical capacity pools on Капитал) takes its position.
 */
const SERIES = ["bg-series-1", "bg-series-2", "bg-series-3"] as const;

const NAMED: Readonly<Record<string, string>> = {
  PRIME: "bg-series-1",
  PULSE: "bg-series-2",
  FLASH: "bg-series-3",
};

export function poolColour(pool: string, position = 0): string {
  return NAMED[pool] ?? SERIES[position % SERIES.length] ?? "bg-series-1";
}
